import type { FluxErrorEntityErrorCodes } from '../types.js';

export const FeatureFlagAccountErrorCodes = {
  FeatureFlagAccountAlreadyExists: {
    code: 'feature-flag-account/already-exists',
    explanation: 'A funcionalidade que você está tentando ativar para esta conta já está ativada.',
    localizations: {},
    message: 'A conta já possui esta funcionalidade ativada.',
  },
  FeatureFlagAccountNotFound: {
    code: 'feature-flag-account/not-found',
    explanation:
      'A funcionalidade que você está tentando acessar não está ativada para esta conta.',
    localizations: {},
    message: 'A funcionalidade não está ativada para esta conta.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'feature-flag-account'>;

export const FeatureFlagErrorCodes = {
  FeatureFlagAlreadyDisabled: {
    code: 'feature-flag/already-disabled',
    explanation: 'A funcionalidade que você está tentando desativar já está desativada.',
    localizations: {},
    message: 'Esta funcionalidade já está desativada.',
  },
  FeatureFlagAlreadyEnabled: {
    code: 'feature-flag/already-enabled',
    explanation: 'A funcionalidade que você está tentando ativar já está ativada.',
    localizations: {},
    message: 'Esta funcionalidade já está ativada.',
  },
  FeatureFlagAlreadyWhitelistOnly: {
    code: 'feature-flag/already-whitelist-only',
    explanation:
      'A funcionalidade que você está tentando configurar para apenas whitelist já está configurada dessa forma.',
    localizations: {},
    message: 'A funcionalidade já está restrita a uma lista específica.',
  },
  FeatureFlagForbidden: {
    code: 'feature-flag/forbidden',
    explanation: 'Essa funcionalidade está em fase de testes e não está disponível publicamente.',
    localizations: {},
    message: 'Essa funcionalidade está em testes e não está disponível publicamente.',
  },
  FeatureFlagInative: {
    code: 'feature-flag/inactive',
    explanation: 'A funcionalidade que você está tentando acessar está inativa.',
    localizations: {},
    message: 'Esta funcionalidade não está disponível no momento.',
  },
  FeatureFlagInvalidSlug: {
    code: 'feature-flag/invalid-slug',
    explanation: 'O slug da funcionalidade é inválido. Verifique se o identificador está correto.',
    localizations: {},
    message: 'O identificador da funcionalidade é inválido.',
  },
  FeatureFlagNotFound: {
    code: 'feature-flag/not-found',
    explanation: 'A funcionalidade que você está tentando acessar não foi encontrada.',
    localizations: {},
    message: 'A funcionalidade solicitada não foi encontrada.',
  },
  FeatureFlagNotWhitelistOnly: {
    code: 'feature-flag/not-whitelist-only',
    explanation:
      'A funcionalidade que você está tentando acessar não está configurada para apenas whitelist.',
    localizations: {},
    message: 'A funcionalidade não está configurada para lista restrita.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'feature-flag'>;
